import { render } from "./CompletionResult.vue?vue&type=template&id=dbb2ed28&scoped=true"
import script from "./CompletionResult.vue?vue&type=script&lang=js"
export * from "./CompletionResult.vue?vue&type=script&lang=js"

import "./CompletionResult.vue?vue&type=style&index=0&id=dbb2ed28&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb2ed28"]])

export default __exports__